import { PureLightTheme } from "../../../styles/theme";
import { MOBILE_FIXED_BOTTOM_BASE } from "../../../consts/mobileLayout";

export const MainStackStyle = {
  justifyContent: 'center',
  height: "100%",
  gap: 2, 
  padding: '0px 8px', 
  '@media (max-width:1200px)': {
    gap: 1,
  },
  [PureLightTheme.breakpoints.down('md')]: {
    padding: 0, 
  },
}

export const CommentsTabsStack = {
  minWidth: 0,
  mt: '50px',
  maxWidth: '736px',
  width: '100%',
  gap: 2,
  [PureLightTheme.breakpoints.down('md')]: {
    maxWidth: '760px',
    mt: '15px',
    padding: "0px 12px",
    mb: 4.5,
  },
}

export const CommentsButton = {
  position: "fixed",
  bottom: MOBILE_FIXED_BOTTOM_BASE,
  maxWidth: "712px",
  width: "calc(100% - 24px)",
  height: "40px",
}

export const SideBox = {
  mt: '16px', 
  position: 'sticky', 
  top: 77, 
  alignSelf: 'flex-start', 
  height: 'calc(100vh - 77px - 16px)', // отступ сверху и снизу 
}
